<template>
  <Doughnut :data="chartData" :options="chartOptions" />
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'CommunicationPieChart',
  components: { Doughnut },

  props: {
    // A-side points 0–5 (from Communication.d1 or .d2)
    // B-side is implicit: 5 - value
    value:        { type: Number, required: true },
    labelA:       { type: String, required: true },
    labelB:       { type: String, required: true },
    descriptionA: { type: String, default: '' },
    descriptionB: { type: String, default: '' },
  },

  computed: {
    aPercent() { return Math.round((this.value / 5) * 100) },
    bPercent() { return 100 - this.aPercent },

    chartData() {
      return {
        labels: [this.labelA, this.labelB],
        datasets: [{
          data:            [this.aPercent, this.bPercent],
          backgroundColor: ['rgba(251, 140, 0, 0.20)', 'rgba(56, 142, 60, 0.20)'],
          borderColor:     ['rgba(251, 140, 0, 1)',     'rgba(56, 142, 60, 1)'],
          borderWidth:     1,
        }],
      }
    },

    chartOptions() {
      return {
        responsive:          true,
        maintainAspectRatio: false,
        cutout:              0,
        rotation:            -Math.PI / 2,
        plugins: {
          legend: {
            position: 'bottom',
            reverse:  true,
            labels:   { font: { size: 12 }, padding: 16 },
          },
          tooltip: {
            callbacks: {
              label: ctx => {
                const line = ` ${ctx.label}: ${ctx.parsed}%`
                const desc = ctx.dataIndex === 0 ? this.descriptionA : this.descriptionB
                return desc ? [line, ` ${desc}`] : line
              },
            },
          },
        },
      }
    },
  },
}
</script>
